import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, LayoutDashboard, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "../api";
import { useAuth } from "../auth";

// Shown while a master admin is inside another business. Everything they do there is real.
export default function MasterBar() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!user?.master_view) return null;
  const leave = async (to) => {
    setBusy(true);
    try { await api.post("/master/exit"); const me = await api.get("/auth/me"); setUser(me.data); nav(to); } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="relative z-40 flex h-9 items-center gap-3 bg-[#0A0A0B] px-3 text-[12px] text-zinc-300 sm:px-4" data-testid="master-bar">
      <span className="flex shrink-0 items-center gap-2 font-mono text-[10px] uppercase tracking-[.14em] text-amber-400"><Crown size={11} /> Master<span className="hidden sm:inline"> view</span></span>
      <span className="min-w-0 truncate">Inside <b className="font-semibold text-white" data-testid="master-bar-tenant">{user.tenant?.name}</b> as Admin<span className="hidden text-zinc-500 md:inline"> — real data, real changes</span></span>
      <div className="ml-auto flex shrink-0 items-center gap-1.5">
        <button disabled={busy} onClick={() => leave("/master?tab=businesses")} className="flex items-center gap-1.5 rounded-sm border border-white/15 px-2.5 py-1 text-[12px] hover:border-white/40 disabled:opacity-50" data-testid="master-bar-console"><LayoutDashboard size={12} className="text-amber-400" /><span className="hidden sm:inline">Master console</span><span className="sm:hidden">Console</span></button>
        <button disabled={busy} onClick={() => leave("/")} className="flex items-center gap-1.5 rounded-sm bg-amber-500 px-2.5 py-1 text-[12px] font-semibold text-zinc-950 hover:bg-amber-400 disabled:opacity-50" data-testid="master-bar-exit"><Undo2 size={12} /> Return home</button>
      </div>
    </div>
  );
}
